import { useEffect } from "react";
import { TiBasicLayout } from "@ti/max";

const BasicLayout = () => {
  useEffect(() => {
    checkNeedRelogin();
  }, []);

  /**
   * 重登控制，修改 lastKey 和 currentKey 可以实现效果
   */
  const checkNeedRelogin = () => {
    const lastKey: string = "omc-relogin-v5";
    const currentKey: string = "omc-relogin-v6";
    const needRelogin = localStorage.getItem(currentKey);

    if (currentKey === "" && lastKey !== "") {
      localStorage.removeItem(lastKey);
      return;
    }

    if (needRelogin === null) {
      localStorage.setItem(currentKey, "1");
      if (lastKey) {
        localStorage.removeItem(lastKey);
      }
      // 避免飞书重定向携带参数时，触发该逻辑导致登录失败的问题
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
  };

  return <TiBasicLayout title="OMC" />;
};

export default BasicLayout;
